export const BASE_PAGE_SIZES = [5, 10, 15, 20];

/**
 * Single source of truth for the starting page size on every table — used both
 * as the initial auto-fit guess (desktop, before measuring) and the mobile
 * default. Keeps the "Show entries" dropdown showing the same number on load
 * across the whole app.
 */
export const DEFAULT_PAGE_SIZE = 5;

export interface PageSizeOption {
  value: number;
  label: string;
}

/**
 * Consistent "Show entries" options for every table. The desktop tables
 * auto-fit their page size to the viewport, so the current size may not be one
 * of the base values — we always fold it in and sort, guaranteeing the dropdown
 * shows (and selects) whatever the table is actually displaying.
 */
export function pageSizeOptions(current: number): PageSizeOption[] {
  const sizes = Array.from(new Set([...BASE_PAGE_SIZES, current])).sort(
    (a, b) => a - b,
  );
  return sizes.map((n) => ({ value: n, label: String(n) }));
}
